import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
export const HtmlViewer = ({ filePath, storageType }) => {
    const [fetchedData, setFetchedData] = useState(null);
    useEffect(() => {
        if (storageType === 1) {
            fetch(filePath)
                .then(x => x.text())
                .then(x => setFetchedData(x));
        }
    }, [filePath, storageType]);
    if (storageType === 1) {
        return (_jsx("iframe", { title: "HTML Preview", sandbox: "", style: { border: 'none', width: '100%', height: '100%' }, srcDoc: fetchedData }));
    }
    return (_jsx("iframe", { title: "HTML Preview", sandbox: "", style: { border: 'none', width: '100%', height: '100%' }, src: filePath }));
};
export default HtmlViewer;
